import { SlideFade, Box, BoxProps } from '@chakra-ui/react'
import { navigate, withPrefix } from 'gatsby'
import * as React from 'react'

import { vw } from '../../styles/theme'
import ButtonHamburger from '../buttons/ButtonHamburger'
import ButtonLanguage from '../buttons/ButtonLanguage'
import NavSPGeneralContact from './NavSPGeneralContact'
import NavSPNav from './NavSPNav'
import NavSPPressContact from './NavSPPressContact'
import NavSPSNS from './NavSPSNS'
import useLocale from '../../hooks/useLocale'
import { changeLocale } from 'gatsby-plugin-intl'

const isBrowser = () => typeof location !== 'undefined'

export type NavSPProps = BoxProps & {}

const NavSP: React.FC<NavSPProps> = ({ ...others }) => {
  const [isOpen, setIsOpen] = React.useState(false)

  const handleClick = () => {
    setIsOpen(false)
  }
  const { isEn } = useLocale()
  const setLanguage = async (prefix: string) => {
    if (prefix === 'ja') {
      const path = isBrowser() ? location.pathname : '/'
      const to = path.replace(/^.+?\/en/, '')
      await navigate(to)
    } else {
      changeLocale(prefix)
    }
    handleClick()
  }

  return (
    <>
      <Box pos="relative" {...others}>
        <ButtonHamburger
          pos="fixed"
          zIndex="99999"
          top={vw(6)}
          left="0"
          isOpen={isOpen}
          onClick={() => setIsOpen(!isOpen)}
        />

        <SlideFade
          in={isOpen}
          unmountOnExit={true}
          w="100%"
          h="100%"
          offsetX="-100vw"
          transition={{
            enter: { duration: 0.25 },
          }}
        >
          <Box
            w="100vw"
            minH="100vh"
            backgroundImage={withPrefix('/images/nav_bg_sp.jpg')}
            backgroundSize="cover"
            css={{
              a: {
                textDecoration: 'none',
              },
            }}
          >
            <Box pt={vw(56)} pr={vw(40)} textAlign="right" mb={vw(116)}>
              <ButtonLanguage localizeKey="nav__global__ja" disabled={!isEn} onClick={() => setLanguage('ja')} />
              {' / '}
              <ButtonLanguage localizeKey="nav__global__en" disabled={isEn} onClick={() => setLanguage('en')} />
            </Box>
            <NavSPNav handleClick={handleClick} mb={vw(203)} />
            <NavSPSNS mb={vw(100)} />
            <NavSPGeneralContact mb={vw(100)} />
            <NavSPPressContact pb={vw(336)} />
          </Box>
        </SlideFade>
      </Box>
    </>
  )
}

export default NavSP
